import React, { Component } from "react";
import {
  Menu,
  Item,
  Separator,
  Submenu,
  MenuProvider,
  theme,
  contextMenu
} from "react-contexify";
import "react-contexify/dist/ReactContexify.min.css";

const onClick = ({ event, props }) => console.log(event, props);

class ContextMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  copyObject({ e, props }) {
    this.props.copyToClipBoard(props.object);
  }
  pasteObject({ e, props }) {
    this.props.pasteFromClipBoard();
  }
  removeObject({ e, props }) {
    this.props.removeImage({ key: props.key });
  }
  moveToFront({ e, props }) {
    this.props.moveTo({ direction: "front", key: props.key });
  }

  bringToBack({ e, props }) {
    this.props.moveTo({ direction: "back", key: props.key });
  }
  rotateObject(o, { e, props }) {
    console.log([o, e, props]);
    this.props.rotateHandler({ key: props.key, degree: o });
  }
  render() {
    const menuType = this.props.menu;
    if (menuType === "objects") {
      return (
        <Menu
          id={this.props.menuId}
          theme={theme.dark}
          style={{ zIndex: "9999999999999999999999999" }}
        >
          <Item onClick={this.copyObject.bind(this)}>
            <i className="mdi mdi-copy" />
            Copy
          </Item>
          <Item onClick={this.pasteObject.bind(this)}>Paste</Item>
          <Separator />
          <Item onClick={onClick}>Group</Item>
          <Separator />
          <Submenu label="Arrange">
            <Item onClick={this.moveToFront.bind(this)}>Bring to front</Item>
            <Item onClick={onClick}>Bring forward</Item>
            <Item onClick={onClick}>Send backward</Item>
            <Item onClick={this.bringToBack.bind(this)}>Send to back</Item>
          </Submenu>
          <Submenu label="Transform">
            <Item onClick={this.rotateObject.bind(this, -90)}>
              Rotate 90deg Left
            </Item>
            <Item onClick={this.rotateObject.bind(this, 90)}>
              Rotate 90deg Right
            </Item>
            <Item onClick={onClick}>Flip Horizontal</Item>
            <Item onClick={onClick}>Flip Vertical</Item>
          </Submenu>
          <Separator />
          <Item onClick={this.removeObject.bind(this)}>Remove</Item>
        </Menu>
      );
    } else {
      return (
        <Menu
          id={this.props.menuId}
          theme={theme.dark}
          style={{ zIndex: "9999999999999999999999999" }}
        >
          <Item onClick={onClick} disabled>
            <i className="far fa-copy" />
            Copy
          </Item>
          <Item onClick={this.pasteObject.bind(this)}>Paste</Item>
          <Separator />
          <Item onClick={onClick}>Group</Item>
          <Separator />
          <Submenu label="Arrange" disabled>
            <Item onClick={this.moveToFront.bind(this)}>Bring to front</Item>
            <Item onClick={onClick}>Bring forward</Item>
            <Item onClick={onClick}>Send backward</Item>
            <Item onClick={this.bringToBack.bind(this)}>Send to back</Item>
          </Submenu>
          <Submenu label="Transform" disabled>
            <Item onClick={this.rotateObject.bind(this, "-90")}>
              Rotate 90deg Left
            </Item>
            <Item onClick={this.rotateObject.bind(this, "90")}>
              Rotate 90deg Right
            </Item>
            <Item onClick={onClick}>Flip Horizontal</Item>
            <Item onClick={onClick}>Flip Vertical</Item>
          </Submenu>
          <Separator />
          <Item onClick={this.removeObject.bind(this)}>Remove</Item>
        </Menu>
      );
    }
  }
}

export default ContextMenu;
